import { buildMenu } from "@client/lib/menu";
import { getLogoOptions } from "@client/lib/settings";
import { type CompositeSettings, ScreenType } from "@client/types";
import { type LoaderArgs } from "@client/window";
import { createSelector } from "reselect";
import {
  getCompositeSettingSelector,
  getLayoutColorSelector,
  getLayoutSettingValueSelector,
  siteColorSelector,
  TargetSelector
} from ".";
import { stateSelectors } from "..";
import { createShallowEqualSelector } from "../common";
import { isEditModeSelector, pageIdSelector, pagesItemsSelector, screenSelector } from "../state";

export const makeLogoOptionsSelector = (target: string, prefix?: string) => {
  const compositeSelector = getCompositeSettingSelector<CompositeSettings.Logo>(target, "logo", prefix);
  const isDesktopSelector = createSelector([screenSelector], (screen) => screen === ScreenType.Desktop);

  return createShallowEqualSelector([stateSelectors.portal, compositeSelector, isDesktopSelector], getLogoOptions);
};

export const menuItemsSelector = createSelector([pagesItemsSelector, pageIdSelector], buildMenu);
export const headerElementsColorSelector = getLayoutColorSelector("elementsColor", "header");
export const headerStickyElementsColorSelector = getLayoutColorSelector("elementsColor", "header.sticky");
export const headerHeightSelector = getLayoutSettingValueSelector("height", "header");
export const headerWidthSelector = getLayoutSettingValueSelector("width", "header");

const preloadSettingSelector = getCompositeSettingSelector<{
  color: string;
  colorType: string;
  style: string;
  waitAllModules: boolean;
}>(TargetSelector.Layout, "preloader");
export const loaderArgsSelector = createShallowEqualSelector(
  [siteColorSelector, preloadSettingSelector, isEditModeSelector],
  (siteColor, preloader, isEditMode): LoaderArgs | undefined => {
    if (!preloader) return;

    return {
      color: preloader.colorType === "custom" ? preloader.color : siteColor,
      disableUnload: isEditMode,
      inDuration: 200,
      outDuration: 100,
      style: +preloader.style,
      waitAllModules: preloader.waitAllModules
    };
  }
);
